import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { SapEtaConfigurationFacade } from './sap-eta-configuration.facade';

@Injectable()
export class SapEtaConfigurationGuard  {
  constructor(private sapEtaConfigurationListFacade: SapEtaConfigurationFacade) {}

  canActivate(): Observable<boolean> {
    return loadStoreState(this.sapEtaConfigurationListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.sapEtaConfigurationListFacade);
  }
}
